export default __webpack_public_path__ + "static/media/sav-logo-ink.1650a2f2.png";